// extracted by mini-css-extract-plugin
module.exports = {"container":"BookCard_container__R4Nt1","content":"BookCard_content__WpDkr","name":"BookCard_name__eQwP_","desc":"BookCard_desc__khjPC","extra":"BookCard_extra__MkQ8e"};